import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from "aws-amplify";
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import config from "./config";
import './index.scss';

/**
 * Amplify references:
 * Auth = cognito
 * Storage = S3
 * API = API Gateway
 */

// The mandatorySignIn flag for Auth is set to true because we want
// our users to be signed in before they can interact with our app.

// the name "stories" tells amplify we want to name our API, amplify allows multiple APIs
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [{
      name: "stories",
      endpoint: config.apiGateway.URL,
      region: config.apiGateway.REGION
    }]
  }
});

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js